import { WizardPage } from '../../components/wizard/types';
import { FinanceModel } from '../../api/models';
import { FieldModel } from '../../components/form/pageForm/types';

const cellWidth = '352px';

const afiAppGuidanceText: FieldModel<FinanceModel> = {
    component: 'globalContent',
    label: '',
    name: 'afiAppGuidanceText',
    contentKey: ['AFIAppGuidanceText'],
};

// Question 50
const companyCompletedIncomeYear: FieldModel<FinanceModel> = {
    component: 'textInput',
    label: `What is the company's most recently completed income year?`,
    name: 'companyCompletedIncomeYear',
    maxWidth: '255px',
    componentProps: {
        placeholderText: 'YYYY/YY+1',
    },
};

// Question 51
const applicationOrganisationTaxableIncome: FieldModel<FinanceModel> = {
    component: 'currencyInput',
    label: `For your most recently completed income period, what was the company's taxable income or loss (across all companies)?`,
    contentKey: ['ApplicationOrganisationTaxableIncome'],
    name: 'applicationOrganisationTaxableIncome',
    maxWidth: cellWidth,
    maxLength: 15,
    componentProps: {
        allowNegative: true,
    },
};

// Question 52
const applicationOrganisationAggregatedTurnover: FieldModel<FinanceModel> = {
    component: 'currencyInput',
    label: `For your most recently completed income period, what was the company's aggregated turnover?`,
    contentKey: ['CompanyAggregatedTurnover'],
    name: 'applicationOrganisationAggregatedTurnover',
    maxWidth: cellWidth,
    maxLength: 15,
};

// Question 53
const applicationOrganisationExportSales: FieldModel<FinanceModel> = {
    component: 'currencyInput',
    label: `For your most recently completed income period, how much revenue did the company earn (across all companies) from export sales?`,
    contentKey: ['ApplicationOrganisationExportSales'],
    name: 'applicationOrganisationExportSales',
    maxWidth: cellWidth,
    maxLength: 15,
};

// Question 54
const applicationOrganisationRnDExpenditure: FieldModel<FinanceModel> = {
    component: 'currencyInput',
    label: `For the most recently completed income period, what was the company's R&D Expenditure?`,
    contentKey: ['ApplicationOrganisationRnDExpenditure'],
    name: 'applicationOrganisationRnDExpenditure',
    maxWidth: cellWidth,
    maxLength: 15,
};

const finance: WizardPage<FinanceModel> = {
    enablingPages: [
        'registrationType',
        'rndEntityDetails',
        'contactDetails',
        'applicationInclusions',
        'employees',
    ],
    apiEndpoint: '/finance',
    name: 'finance',
    title: 'Finance',
    fields: {
        afiAppGuidanceText,
        companyCompletedIncomeYear,
        applicationOrganisationTaxableIncome,
        applicationOrganisationAggregatedTurnover,
        applicationOrganisationExportSales,
        applicationOrganisationRnDExpenditure,
    },
    initialPageValues: {
        companyCompletedIncomeYear: '',
        applicationOrganisationTaxableIncome: undefined,
        applicationOrganisationAggregatedTurnover: undefined,
        applicationOrganisationExportSales: undefined,
        applicationOrganisationRnDExpenditure: undefined,
    },
};

export default finance;
